function cleanString(texto) {
  return texto
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, "");
}

export function getImage(aseDescrip, imagen) {
  console.log(aseDescrip, imagen);

  if (!aseDescrip) {
    return imagen;
  }
  const url = `https://res.cloudinary.com/andes-salud/image/upload/c_fit,dpr_1.0,h_380,w_280/procedimiento/`;

  const imageMap = {
    CARDIOLOGIA: 1,
    OTORRINOLARINGOLOGIA: 2,
    GINECOLOGIA: 3,
    NEUROLOGIA: 4,
    BRONCOPULMONAR: 5,
    OFTALMOLOGIA: 6,
    ENFERMERIA: 7,
    VACUNATORIO: 8,
    GASTROENTEROLOGIA: 9,
    CIRUGIAVASCULAR: 10,
    DERMATOLOGIA: 11,
    CIRUGIAMENOR: 12,
    OTROS: 13,
    FUNCIONPULMONAR: 14,
    ENDOSCOPIA: 15,
    KINESIOLOGIA: 16,
    ELECTROENCEFALOGRAMA: 17,
    COLONOSCOPIA: 18,
    UROFLUJOMETRIA: 19,
    PROCEDIMIENTOS: 20,
    TRAUMATOLOGIA: 21,
  };

  const imageNumber = imageMap[cleanString(aseDescrip)] || "default";

  if (imageNumber === "default") {
    return imagen;
  }

  return `${url}${imageNumber}.jpg`;
}
